import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './../../public/images/g.jpg';
const _withScopeId = n => (_pushScopeId("data-v-f3952604"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "dialog-footer"
};
const _hoisted_2 = {
  class: "toolbar"
};
const _hoisted_3 = {
  class: "user"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 1,
  src: _imports_0
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-xitongfuwu"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_userEdit = _resolveComponent("userEdit");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_badge = _resolveComponent("el-badge");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_affix = _resolveComponent("el-affix");
  return _openBlock(), _createBlock(_component_el_affix, {
    offset: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_dialog, {
      modelValue: _ctx.userEditShow,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.userEditShow = $event),
      title: _ctx.actionTitle,
      width: "500px",
      "align-center": ""
    }, {
      footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: $options.editSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("确认" + _toDisplayString(_ctx.action == 'add' ? '添加' : '修改'), 1)]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = $event => _ctx.userEditShow = false)
      }, {
        default: _withCtx(() => [_createTextVNode("关　闭")]),
        _: 1
      })])]),
      default: _withCtx(() => [_ctx.userEditShow ? (_openBlock(), _createBlock(_component_userEdit, {
        key: 0,
        ref: "userEdit",
        action: _ctx.action,
        actionUrl: _ctx.actionUrl,
        userDataOne: _ctx.userDataOne,
        onUserEdit_close: $options.userEdit_close,
        onNoLogout: $options.noLogout
      }, null, 8, ["action", "actionUrl", "userDataOne", "onUserEdit_close", "onNoLogout"])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["modelValue", "title"]), _createVNode(_component_el_header, {
      style: {
        "text-align": "right",
        "font-size": "12px"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, {
        gutter: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 1
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: "iconfont icon-24px",
            onClick: _cache[2] || (_cache[2] = (...args) => $options.isCollapse && $options.isCollapse(...args))
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 15
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_badge, {
            "is-dot": "",
            class: "message"
          }, {
            default: _withCtx(() => [_createElementVNode("i", {
              class: "iconfont icon-xiaoxi",
              onClick: _cache[3] || (_cache[3] = $event => $options.message())
            })]),
            _: 1
          }), _createElementVNode("div", _hoisted_3, [_ctx.userInfo.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.userInfo.avatar
          }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("img", _hoisted_5)), _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.username), 1)]), _createVNode(_component_el_dropdown, null, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                onClick: $options.userEdit
              }, {
                default: _withCtx(() => [_createTextVNode("修改帐号")]),
                _: 1
              }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
                onClick: $options.logout
              }, {
                default: _withCtx(() => [_createTextVNode("退出登录")]),
                _: 1
              }, 8, ["onClick"])]),
              _: 1
            })]),
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])]),
      _: 1
    }), ($options.tabs.length > 0 && 1 == 0 ? true : false) ? (_openBlock(), _createBlock(_component_el_tabs, {
      key: 0,
      modelValue: $options.tabValue,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $options.tabValue = $event),
      type: "card",
      class: "tabs",
      closable: "",
      onTabChange: $options.tabChange,
      onTabRemove: $options.removeTab
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tabs, item => {
        return _openBlock(), _createBlock(_component_el_tab_pane, {
          key: item.name,
          label: item.title,
          name: item.name,
          class: "tab-pane"
        }, null, 8, ["label", "name"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue", "onTabChange", "onTabRemove"])) : _createCommentVNode("", true)]),
    _: 1
  });
}